// extracted by mini-css-extract-plugin
module.exports = {"box":"TableComponent_box__CdNIB","table":"TableComponent_table__2-Yyg"};